<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section">
    <h2>Assurance Multirisque Professionnelle - Local - Bureaux - Commerce</h2>
    <p>
      L'Assurance multirisque professionnelle regroupe l'ensemble des garanties appliquées à l'activité de l'entreprise. Souvent appelée l'assurance des locaux, 
      elle est l'équivalent de l'assurance habitation pour les particuliers. A ce titre elle assure le contenu des locaux professionnels, c'est à dire tout ce qu'il y a 
      à l'intérieur d'un bureau, usine, hangar, restaurant, discothèque, boutique, etc etc. Sans cette assurance, difficile de signer un bail commercial avec le propriétaire. 
      En plus de la protection de votre contenu, elle offre différentes protections financières.
    </p>
    <p>
      Elle garantit notamment dans un tarif unique les risques suivants :
    </p>
  </div>

  <div class="content-section bg-light">
    <h2 class="section-title-purple">Risques garanties dans les locaux professionnels :</h2>
    <ol class="numbered-list">
      <li>Incendie, vandalisme,</li>
      <li>Evénements naturels,</li>
      <li>Catastrophes naturelles,</li>
      <li>Evénements climatiques,</li>
      <li>Attentats – actes de terrorisme,</li>
      <li>Dégâts des eaux,</li>
      <li>Vol - Détériorations immobilières des locaux,</li>
      <li>Vol - Contenu,</li>
      <li>Vol - Fonds et valeurs,</li>
      <li>Bris et dommages électriques des matériels informatiques et d'exploitation,</li>
      <li>Pertes de denrées en congélateurs et chambres froides,</li>
      <li>Objets d'art et d'ornement,</li>
      <li>Autres événements accidentels non prévus par ailleurs,</li>
      <li>Matériels de production d'énergies renouvelables,</li>
      <li>Parc à vin,</li>
      <li>Augmentation automatique des capitaux</li>
    </ol>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">Risques garanties hors locaux professionnels :</h2>
    <ol class="numbered-list">
      <li>Marchés, salons, foires et manifestations,</li>
      <li>Transports et livraison de matériels et marchandises,</li>
      <li>Matériel professionnel hors local.</li>
    </ol>
  </div>

  <div class="content-section bg-accent">
    <h2 class="section-title-purple">Poursuite de l'activité en cas de sinistre :</h2>
    <ol class="numbered-list">
      <li>Frais nécessaire de poursuite d'activité (Frais supp),</li>
      <li>Pertes d'exploitation suite à dommages matériel,</li>
      <li>Perte de la valeur vénale du fonds de commerce,</li>
      <li>Perte d'exploitation suite à un accident corporel,</li>
      <li>Perte d'exploitation suite à COVID</li>
      <li>Perte d'exploitation suite à PANDEMIE</li>
    </ol>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">Responsabilité et juridique :</h2>
    <ol class="numbered-list">
      <li>Responsabilité Civile,</li>
      <li>Recours amiables et judiciaires,</li>
      <li>Protection Juridique.</li>
    </ol>
  </div>

  <div class="content-section bg-light">
    <h2 class="section-title-purple">Le saviez-vous ?</h2>
    <p>
      La plupart des garanties peuvent être souscrites individuellement :
    </p>
    <ul class="simple-list">
      <li>RC : <a href="#">Assurance Responsabilité Civile</a>,</li>
      <li>PJ : <a href="#">Assurance Protection Juridique Professionnelle</a>,</li>
      <li>Matériel Informatique</li>
      <li>Perte d'exploitation : <a href="#">Assurance Perte d'Exploitation</a></li>
      <li>Bris de Machine : <a href="#">Assurance Bris de Machine</a></li>
    </ul>
  </div>

  <div class="content-section">
    <p>
      En tant que courtier en assurance partenaire de nombreux assureurs spécialisés sur le risque des professionnels et des entreprises comme 
      <strong>GENERALI, AXA, PROGEAS, SOLLY AZAR, SURAVENIR, HELVETIA, TETRIS ALLIANZ</strong>, nous sommes en mesure de vous trouver la couverture 
      la plus complète avec le meilleur rapport qualité / prix.
    </p>
  </div>
</app-page-layout>
